(() => {
    const $siteMain = document.querySelector('.site-main');

    if (!$siteMain) return;

    const checkScreenBGColourChangeSections = () => {
        const $changeScreenBackgroundColours = document.querySelectorAll('.change-screen-background-colour');

        if (!$changeScreenBackgroundColours) return;

        const { currentActiveColour } = $siteMain?.dataset;
        let activeColour = false;

        $changeScreenBackgroundColours.forEach($screenBGColourChangeSection => {
            const { changeScreenBackgroundColour } = $screenBGColourChangeSection.dataset;
            
            if (!changeScreenBackgroundColour) return;

            if ($screenBGColourChangeSection.getBoundingClientRect().top <= (window.innerHeight * 0.25)) {
                activeColour = changeScreenBackgroundColour;
            }
        });

        $siteMain.classList.remove('site-main--background-white', 'site-main--background-light-blue', 'site-main--background-dark-blue', 'site-main--background-purple');

        if (activeColour && activeColour !== currentActiveColour) {
            $siteMain.dataset = activeColour;
            $siteMain.classList.add(`site-main--background-${activeColour}`);
        }
    };

    window.addEventListener('scroll', () => {
        checkScreenBGColourChangeSections();
    });

    window.addEventListener('load', () => {
        checkScreenBGColourChangeSections();
    });

    checkScreenBGColourChangeSections();
})();
